import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_f54zfgydnm: FaireCollectionEntity = {
  token: "pbc_f54zfgydnm",
  type: "collection",
  name: "Mommy & Me Cozy Sweater Knit Collection",
  heroImageUrl:
    "https://cdn.faire.com/fastly/20b02c10d8e8a21e0eeb1b010139f68bd0f0a465b43c18b12e28e77689a5e483.jpeg",
  itemCount: 4,
  description:
    "This coordinated collection features women’s and baby sweaters crafted from certified organic cotton. Designed for comfort and everyday wear, these cozy knits offer timeless styles that make matching easy—perfect for gifting, family moments, and cooler seasons.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:16.333Z",
    importedBy: "entity-db-import-collections",
  },
};
